

export const types = {

    login:  '[Auth] Login',
    logout: '[Auth] Logout',

    uiStartLoading: '[UI] Start loading',
    uiFinishLoading: '[UI] Finish loading',

    uiSetError: '[UI] Set Error',
    uiRemoveError: '[UI] Remove Error',

    addError: '[Auth] AddError', 
    removeError: '[Auth] RemoveError', 

    userNotFound: 'User not found',

    setDataVideo: 'Set Data Video',
}

